module.exports = __webpack_public_path__ + "static/media/whatsapp.1aa77925.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/whatsapp.svg
// module id = 919
// module chunks = 7